import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const uploadGorgiasMacros = {
  name: "uploadGorgiasMacros" as const,
  input: z.object({
    teamId: zExt.objectId(),
    fileName: z.string(),
    fileContent: z.string(),
    mimeType: z.string(),
  }),
  output: z.object({ importedCount: z.number(), skippedCount: z.number() }),
};
